module.exports = __webpack_public_path__ + "static/media/orthodoxZikaronLogo.f965efe7.svg";